export enum BrandCardSource {
  DISCOVER_BRAND = "discoverBrands",
  ONBOARDING_BRAND = "onboardingBrands",
  SIMILAR_BRANDS = "similarBrands",
}
